/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersinviteqrdownload3Inputs */

const en_membersinviteqrdownload3 = /** @type {(inputs: Membersinviteqrdownload3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download QR code`)
};

const de_membersinviteqrdownload3 = /** @type {(inputs: Membersinviteqrdownload3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code herunterladen`)
};

/**
* | output |
* | --- |
* | "Download QR code" |
*
* @param {Membersinviteqrdownload3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersinviteqrdownload3 = /** @type {((inputs?: Membersinviteqrdownload3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersinviteqrdownload3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersinviteqrdownload3(inputs)
	return de_membersinviteqrdownload3(inputs)
});
export { membersinviteqrdownload3 as "membersInviteQrDownload" }